import React, { useEffect, useState } from 'react';
import './styles.css';


import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import UpdateIcon from '@mui/icons-material/Update';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import api from '../../services/api';

import Notification from '../../components/Notification/Notification';
import ConfirmDialog from '../../components/Notification/ConfirmDialog';
import ModalDescriptionStatus from './ModalDescriptionStatus';
import useStyles from './stylesUpdateComplaint';

export default function UpdateComplait({ areas, executor, controlador, complaints, userPermission, idComplaint, status }) {
  const classes = useStyles();

  const [openModalDescription, setOpenModalDescription] = useState(false);

  const [areaSelect, setAreaSelect] = useState("");
  const [statusSelect, setStatusSelect] = useState("");
  const [executorSelect, setExecutorSelect] = useState("");
  const [controladorSelect, setControladorSelect] = useState("");
  const [homologadoSelect, setHomologadoSelect] = useState("");

  const [allStatuses, setAllStatuses] = useState([])

  // Alerta
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '', title: '' })
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })

  /* ************************************************************************** */
  /* Lógica para capturar somente os usuários relacionados a área da ocorrência */
  /* OBS: melhorar para ficar mais legível */
  // área relacionada a ocorrência.
  const complaintArea = complaints.map(res => res.area);

  // usuário vinculados a área da ocorrência
  let userExecutorArea = [];

  for (var i in executor) {
    for (var j in executor[i].executor) {
      if (executor[i].executor[j].name === complaintArea[0]) {
        userExecutorArea.push(executor[i]);
      }
    }
  }

  let userControladorArea = [];

  for (var k in controlador) {
    for (var l in controlador[k].manager) {
      if (controlador[k].manager[l].name === complaintArea[0]) {
        userControladorArea.push(controlador[k]);
      }
    }
  }
  /* ************************************************************************** */

  //chama o alerta para atualizar
  function confirms(e) {
    e.preventDefault();

    if (statusSelect !== status)
      setOpenModalDescription(true);
    else
      onCloseModalDescription();
  }

  const onCloseModalDescription = (description) => {
    setConfirmDialog({
      isOpen: true,
      title: `Deseja atualizar os dados da ocorrência ?`,
      subTitle: ``,
      onConfirm: () => { handleUpdate(description) }
    })
  }

  // Realiza atualização 
  async function handleUpdate(description) {
    const detailsComplaint = complaints[0];

    if (areaSelect === "") {
      setAreaSelect(complaints[0].area);
    } else {
      detailsComplaint.area = areaSelect;
    }

    if (statusSelect === "") {
      setStatusSelect(complaints[0].status);
    } else {
      detailsComplaint.status = statusSelect;
    }

    if (executorSelect === "") {
    } else if (executorSelect === "remover") {
      detailsComplaint.executorId = undefined;
      detailsComplaint.executorName = undefined;
    } else {
      detailsComplaint.executorId = executorSelect;
      let getExecutorConsulta = (await api.get(`${userPermission}/users/${executorSelect}`)).data;
      detailsComplaint.executorName = getExecutorConsulta.name;
    }

    if (controladorSelect === "") {
    } else if (controladorSelect === "remover") {
      detailsComplaint.controladorId = undefined;
      detailsComplaint.controladorName = undefined;
    } else {
      detailsComplaint.controladorId = controladorSelect;
      let getControladorConsulta = (await api.get(`${userPermission}/users/${controladorSelect}`)).data;
      detailsComplaint.controladorName = getControladorConsulta.name;
    }

    if (homologadoSelect === "") {
      setHomologadoSelect(complaints[0].validationControl);
    } else {
      if (homologadoSelect === "Não")
        detailsComplaint.validationControl = false;
      else
        detailsComplaint.validationControl = true;
    }

    detailsComplaint.status_description = description;


    // obs: embora o objeto acima tenha campos que em tese o executor não pode alterar 
    //      (validationControl ou executor por exemplo), não haverá impactos na aplicação visto
    //      que o executor não tem visibilidade para os filtros que alteram esses campos.
    const data = (({ area, executorId, executorName, controladorId, controladorName, status, validationControl, status_description }) =>
      ({ area, executorId, executorName, controladorId, controladorName, status, validationControl, status_description }))(detailsComplaint);

    try {
      /* Dependendo do usuário, somente alguns campos podem ser atualizados */
      if (userPermission === 'executor' || userPermission === 'manager') {
        await api.put(`${userPermission}/complaints/${idComplaint}`, data);
        //alert(`Ocorrência atualizada com sucesso.`);
        setNotify({
          isOpen: true,
          message: 'Ocorrência atualizada com sucesso.',
          type: 'success',
          title: ''
        });
        window.location.reload();
        /* se for admin */
      } else {
        await api.put(`${userPermission}/complaints/${idComplaint}`, data);
        //alert(`Ocorrência atualizada com sucesso.`);
        setNotify({
          isOpen: true,
          message: 'Ocorrência atualizada com sucesso.',
          type: 'success',
          title: ''
        });
        window.location.reload();
      }

    } catch (err) {
      let message = err?.response?.data?.error?.message;
      setNotify({
        isOpen: true,
        message: message || 'Ocorreu um erro ao atualizar a ocorrência.',
        type: 'error',
        title: 'Erro'
      });
    }
  } // Realiza atualização 


  /* Pegar todas as categorias para listar no select com value === name */
  useEffect(() => {
    async function getAllStatuses() {
      try {
        const response = await api.get(`/complaint-statuses`)
        setAllStatuses(response.data)
      } catch {
        console.log('Erro ao buscar categorias')
      }
    }
    getAllStatuses()
  }, [])

  function updateStatus() {
    return (
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel>Status</InputLabel>
        <Select native label="Status" onChange={e => setStatusSelect(e.target.value)}>
          <option value={""}></option>
          {allStatuses.map((status) => (
            <option key={status.id} value={status.name}>
              {status.name}
            </option>)
          )}
          {/* <option value="Homologado">Homologado</option> */}
        </Select>
      </FormControl>
    );
  }

  function updateArea() {
    return (
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel>Categoria</InputLabel>
        <Select native label="Categoria" onChange={e => setAreaSelect(e.target.value)}>
          <option value="" />
          {areas.map(res => (
            <option key={res.id}>
              {res.name}
            </option>)
          )}
        </Select>
      </FormControl>
    );
  }

  function updateExecutor() {
    return (
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel>Executor</InputLabel>
        <Select native label="Executor" onChange={e => setExecutorSelect(e.target.value)}>
          <option value="" />
          <option value="remover">Remover atribuição</option>
          {userExecutorArea.map(res => (
            <option key={res.id} value={res.id}>
              {res.name}
            </option>)
          )}
        </Select>
      </FormControl>
    );
  }

  function updateControlador() {
    return (
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel>Controlador</InputLabel>
        <Select native label="Controlador" onChange={e => setControladorSelect(e.target.value)}>
          <option value="" />
          <option value="remover">Remover atribuição</option>
          {userControladorArea.map(res => (
            <option key={res.id} value={res.id}>
              {res.name}
            </option>)
          )}
        </Select>
      </FormControl>
    );
  }

  function updateHomologated() {
    return (
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel>Homologado</InputLabel>
        <Select native label="Homologado" onChange={e => setHomologadoSelect(e.target.value)}>
          <option value="" />
          <option value="Sim">Sim</option>
          <option value="Não">Não</option>
        </Select>
      </FormControl>
    );
  }

  return (
    <main>
      <Paper className={classes.paper}>
        <Typography
          variant="h6"
          align="left"
          style={{
            color: '#103168',
            fontWeight: 600,
            textAlign: 'center',
            marginBottom: 20
          }}
        >
          Editar Ocorrência
        </Typography>

        <Typography variant="body2" align="justify" className={classes.textDescription}>
          Deseja editar a ocorrência? Selecione as opções abaixo para modificar o
          status da ocorrência, a sua categoria, o executor responsável e/ou o controlador
          responsável. As informações poderão ser alteradas a qualquer momento.
        </Typography>

        <form onSubmit={confirms} style={{ marginTop: 10 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              {updateStatus()}
            </Grid>

            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
              {userPermission !== 'executor' ?
                updateArea()
                : false}
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              {userPermission !== 'executor' ?
                updateExecutor()
                : false}
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              {userPermission !== 'executor' ?
                updateControlador()
                : false}
            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              {userPermission !== 'executor' ?
                updateHomologated()
                : false}
            </Grid>
          </Grid>

          <Button
            className={classes.buttonSubmit}
            variant="outlined"
            startIcon={<UpdateIcon style={{ 'color': '#fff' }} />}
            type="submit"
          >
            Atualizar Ocorrência
          </Button>
        </form>
        <Notification
          notify={notify}
          setNotify={setNotify}
        />
        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
        <ModalDescriptionStatus
          open={openModalDescription}
          setOpen={setOpenModalDescription}
          onClose={onCloseModalDescription}
        />
      </Paper>
    </main>
  );
};